/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { CheckAdvancedSearchHistoryExistsDto } from '../../models/check-advanced-search-history-exists-dto';

export interface CheckAdvancedSearchHistoryExists$Params {
  search_name: string;
}

export function checkAdvancedSearchHistoryExists(
  http: HttpClient,
  rootUrl: string,
  params: CheckAdvancedSearchHistoryExists$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<CheckAdvancedSearchHistoryExistsDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    checkAdvancedSearchHistoryExists.PATH,
    'get',
  );
  if (params) {
    rb.query('search_name', params.search_name, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CheckAdvancedSearchHistoryExistsDto>;
      }),
    );
}

checkAdvancedSearchHistoryExists.PATH = '/me/advanced-search-history/exists';
